export class ComboItem {
  id: string;
  price: number;
  priceChanges: any;
  filter: string | number;
  order: number;
  default: boolean;
  providerData: any;

  constructor(
    id: string,
    price: number,
    filter: string | number,
    order: number,
    isDefault = false,
    priceChanges = null,
    providerData = null,
  ) {
    this.id = id;
    this.price = price;
    this.priceChanges = priceChanges;
    this.filter = filter;
    this.order = order;
    this.default = isDefault;
    this.providerData = providerData;
  }

  toGenericObject() {
    return JSON.parse(JSON.stringify(this));
  }
}
